class LookbookComponent extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = 0;
    this.hotspots = this.querySelectorAll('.lookbook__hotspot');
    this.cards = this.querySelectorAll('.lookbook-card');
    this.dots = this.querySelectorAll('.lookbook__page-dot');
    this.navButtons = this.querySelectorAll('.lookbook__nav');
    this.count = this.cards.length;

    this.onHotspotClick = this.onHotspotClick.bind(this);
    this.onDotClick = this.onDotClick.bind(this);
    this.onNavClick = this.onNavClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.hotspots.forEach((el) => el.addEventListener('click', this.onHotspotClick));
    this.dots.forEach((el) => el.addEventListener('click', this.onDotClick));
    this.navButtons.forEach((el) => el.addEventListener('click', this.onNavClick));
    this.addEventListener('keydown', this.onKeydown);
    this.setActive(0, false);
  }

  disconnectedCallback() {
    this.hotspots.forEach((el) => el.removeEventListener('click', this.onHotspotClick));
    this.dots.forEach((el) => el.removeEventListener('click', this.onDotClick));
    this.navButtons.forEach((el) => el.removeEventListener('click', this.onNavClick));
    this.removeEventListener('keydown', this.onKeydown);
  }

  onHotspotClick(event) {
    const idx = parseInt(event.currentTarget.dataset.index, 10);
    this.setActive(idx);
  }

  onDotClick(event) {
    const idx = parseInt(event.currentTarget.dataset.index, 10);
    this.setActive(idx);
  }

  onNavClick(event) {
    const direction = event.currentTarget.dataset.direction;
    const delta = direction === 'next' ? 1 : -1;
    const idx = (this.activeIndex + delta + this.count) % this.count;
    this.setActive(idx);
  }

  onKeydown(event) {
    if (this.count <= 1) return;
    const tag = event.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.setActive((this.activeIndex - 1 + this.count) % this.count);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.setActive((this.activeIndex + 1) % this.count);
    }
  }

  setActive(index, announce = true) {
    if (index < 0 || index >= this.count) return;
    this.activeIndex = index;

    this.hotspots.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.cards.forEach((el, i) => {
      el.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    this.dots.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (announce) {
      const activeCard = this.cards[index];
      if (activeCard) {
        const title = activeCard.querySelector('.lookbook-card__title');
        if (title) {
          activeCard.setAttribute('aria-live', 'polite');
        }
      }
    }
  }
}

if (!customElements.get('lookbook-component')) {
  customElements.define('lookbook-component', LookbookComponent);
}
